import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { navigate } from "vike/client/router"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import PubSub from "pubsub-js"
import TopRightPageBg from "../TopRightPageBg"

const PartnerWithUsHeader = () => {
  return (
    <CMSRender
      contentType="PageSection"
      match={{ "content.name": "PartnerWithUsHeader" }}
      renderItem={(data, id) => {
        
        const handleContact = () => PubSub.publish( data.menu?.[0].options?.action )

        return (
          <div className="relative w-full bg-gradient_header overflow-hidden">
            <div
              key={id}
              className="flex flex-col lg:flex-row items-center justify-between w-full max-w-[628px] lg:max-w-w2_l xl:max-w-w2_xl gap-[60px] lg:gap-[30px] px-4 md:px-px1_l xl:px-px1_xl pt-[60px] pb-[80px] lg:py-[88px] mx-auto"
            >
              {/* Left Section */}
              <div className="w-full max-w-[500px] md:max-w-[600px] lg:max-w-[640px] xl:max-w-[560px] lg:w-[60%] xl:w-1/2 flex flex-col items-center lg:items-start gap-[30px] lg:gap-[10px]">
                {/* Title */}
                <Typography
                  variant="h1"
                  className="text-text text-center lg:text-left"
                >
                  {data.title}
                </Typography>

                {/* Description */}
                <Typography
                  variant="body1"
                  className="text-center lg:text-left"
                >
                  {data.description}
                </Typography>

                {/* Button */}
                <Button
                  key={id}
                  onClick={handleContact}
                  variant="primary_l"
                  className="max-w-[310px]"
                >
                  {data.menu?.[0]?.label}
                </Button>
              </div>

              {/* Right Section */}
              <div className="w-full lg:w-1/2 max-w-[628px] aspect-628/430 rounded-[50px] overflow-hidden">
                <img
                  src={data.images?.[0]}
                  alt={data.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <TopRightPageBg />
          </div>
        )
      }}
    />
  )
}

export default PartnerWithUsHeader
